import React from "react";
import UpdateShortCode from "./UpdateShortCode";
import { useParams } from "react-router-dom";

export function DisplayShortCode(props) {
    const param = useParams();
    return <UpdateShortCode param={param} {...props} />
}
